import React from "react";

const EmptyPage = ({ message }) => {
	const styleContainer = {
		height: "50vh",
		backgroundColor: "#f9f9f9",
		fontSize: "28px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	};
	const styleHeader = {
		color: "#d0d0d0",
	};

	return (
		<div style={styleContainer}>
			<h3 style={styleHeader}>{message}</h3>
		</div>
	);
};

export default EmptyPage;
